const initializeCardYotpoSkeletons = (container = document) => {
  container.querySelectorAll('.card-product-yotpo-rating-slot').forEach((slot) => {
    if (slot.dataset.yotpoSkeletonInitialized) return;

    const skeleton = slot.querySelector('.card-product-yotpo-skeleton');
    const mount = slot.querySelector('.yotpo-widget-instance');
    if (!skeleton || !mount) return;

    let removed = false;
    let ratingsObserver;
    const isReady = () => mount.querySelector('.yotpo-reviews-star-ratings-widget');
    const removeSkeleton = () => {
      if (removed) return;

      removed = true;
      skeleton.remove();
      observer.disconnect();
      ratingsObserver?.disconnect();
    };
    const observer = new MutationObserver(() => {
      if (isReady()) removeSkeleton();
    });
    const productId = mount.dataset.yotpoProductId;
    const isRatingsRequest = (entry) => {
      const url = new URL(entry.name);
      return ['fetch', 'xmlhttprequest'].includes(entry.initiatorType) && url.pathname.endsWith(`/product/${productId}/ratings`);
    };
    const inspectRatings = (entry) => {
      ratingsObserver.disconnect();
      fetch(entry.name)
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (data?.bottomline?.totalReviews === 0) removeSkeleton();
        })
        .catch(() => {});
    };

    slot.dataset.yotpoSkeletonInitialized = 'true';
    if (isReady()) {
      removeSkeleton();
      return;
    }

    observer.observe(mount, { childList: true, subtree: true });
    if (!productId || !window.PerformanceObserver) return;

    ratingsObserver = new PerformanceObserver((entries) => {
      entries.getEntries().some((entry) => {
        if (!isRatingsRequest(entry)) return false;

        inspectRatings(entry);
        return true;
      });
    });
    ratingsObserver.observe({ type: 'resource', buffered: true });
  });
};

const initializeHomeYotpoSkeletons = (container = document) => {
  container.querySelectorAll('.home-yotpo-reviews-skeleton').forEach((skeleton) => {
    const wrapper = skeleton.parentElement;
    if (!wrapper) return;

    const removeSkeleton = () => {
      skeleton.remove();
      observer.disconnect();
    };
    const isReady = () => wrapper.querySelector('.yotpo-reviews-carousel-widget-clear .yotpo-reviews-carousel-widget-container');
    const observer = new MutationObserver(() => {
      if (isReady()) removeSkeleton();
    });

    if (isReady()) {
      removeSkeleton();
      return;
    }

    observer.observe(wrapper, { childList: true, subtree: true });
  });
};

initializeCardYotpoSkeletons();
const initializePdpYotpoSkeletons = (container = document) => {
  container.querySelectorAll('.pdp-yotpo-reviews-skeleton').forEach((skeleton) => {
    const mount = skeleton.closest('.yotpo-widget-instance');
    if (!mount) return;

    const removeSkeleton = () => {
      skeleton.remove();
      observer.disconnect();
    };
    const isReady = () => mount.querySelector('.yotpo-main-widget-layout, .yotpo-reviews-main-widget');
    const observer = new MutationObserver(() => {
      if (isReady()) removeSkeleton();
    });

    if (isReady()) {
      removeSkeleton();
      return;
    }

    observer.observe(mount, { childList: true, subtree: true });
  });
};

const initializePdpImpYotpoSkeletons = (container = document) => {
  const mounts = container.querySelectorAll('#yotpo-imp-skeleton');
  if (!mounts.length) return;

  mounts.forEach((mount) => {
    if (mount.dataset.yotpoImpSkeletonInitialized) return;

    const skeleton = document.createElement('div');
    skeleton.className = 'pdp-yotpo-imp-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = `
      <div class="pdp-yotpo-imp-skeleton__heading skeleton-shimmer"></div>
      <div class="pdp-yotpo-imp-skeleton__summary"><div class="pdp-yotpo-imp-skeleton__overall"><div class="pdp-yotpo-imp-skeleton__score skeleton-shimmer"></div><div class="pdp-yotpo-imp-skeleton__stars">${'<span class="pdp-yotpo-imp-skeleton__star skeleton-shimmer"></span>'.repeat(5)}</div><div class="pdp-yotpo-imp-skeleton__count skeleton-shimmer"></div></div><div class="pdp-yotpo-imp-skeleton__distribution">${'<div class="pdp-yotpo-imp-skeleton__distribution-row"><span class="pdp-yotpo-imp-skeleton__distribution-label skeleton-shimmer"></span><span class="pdp-yotpo-imp-skeleton__distribution-bar skeleton-shimmer"></span></div>'.repeat(5)}</div><div class="pdp-yotpo-imp-skeleton__button skeleton-shimmer"></div></div>
      <div class="pdp-yotpo-imp-skeleton__filters"><div class="pdp-yotpo-imp-skeleton__search skeleton-shimmer"></div><div class="pdp-yotpo-imp-skeleton__filter skeleton-shimmer"></div><div class="pdp-yotpo-imp-skeleton__filter skeleton-shimmer"></div></div>
      <div class="pdp-yotpo-imp-skeleton__topics">${'<span class="pdp-yotpo-imp-skeleton__topic skeleton-shimmer"></span>'.repeat(4)}</div><div class="pdp-yotpo-imp-skeleton__divider"></div>
      <div class="pdp-yotpo-imp-skeleton__review-list">${'<div class="pdp-yotpo-imp-review-skeleton"><div class="pdp-yotpo-imp-review-skeleton__reviewer skeleton-shimmer"></div><div class="pdp-yotpo-imp-review-skeleton__meta skeleton-shimmer"></div><div class="pdp-yotpo-imp-review-skeleton__title skeleton-shimmer"></div><div class="pdp-yotpo-imp-review-skeleton__content"><span class="skeleton-shimmer"></span><span class="skeleton-shimmer"></span><span class="skeleton-shimmer"></span></div><div class="pdp-yotpo-imp-review-skeleton__date skeleton-shimmer"></div></div>'.repeat(3)}</div>
    `;
    mount.append(skeleton);
    mount.dataset.yotpoImpSkeletonInitialized = 'true';

    const mainContent = mount.closest('#MainContent');
    if (!mainContent) return;

    const removeSkeleton = () => {
      skeleton.remove();
      observer.disconnect();
    };
    const isReady = () => mainContent.querySelector('.yotpo-main-reviews-widget');
    const observer = new MutationObserver(() => {
      if (isReady()) removeSkeleton();
    });

    if (isReady()) {
      removeSkeleton();
      return;
    }

    observer.observe(mainContent, { childList: true, subtree: true });
  });
};

initializeCardYotpoSkeletons();
initializeHomeYotpoSkeletons();
const initializePdpRatingSkeletons = (container = document) => {
  container.querySelectorAll('.pdp-reviews-rewards').forEach((ratingContainer) => {
    const mount = ratingContainer.querySelector('.yotpo.bottomLine');
    if (!mount || mount.dataset.pdpRatingSkeletonInitialized) return;

    const slot = document.createElement('span');
    slot.className = 'pdp-rating-yotpo-skeleton-slot';
    slot.innerHTML = `<span class="pdp-rating-yotpo-skeleton" aria-hidden="true">${'<span class="pdp-rating-yotpo-skeleton__star skeleton-shimmer"></span>'.repeat(5)}<span class="pdp-rating-yotpo-skeleton__count skeleton-shimmer"></span></span>`;
    mount.append(slot);
    mount.dataset.pdpRatingSkeletonInitialized = 'true';

    const removeSkeleton = () => {
      slot.remove();
      observer.disconnect();
    };
    const isReady = () => mount.querySelector('.yotpo-stars, .yotpo-sr-bottom-line-summary');
    const observer = new MutationObserver(() => {
      if (isReady()) removeSkeleton();
    });

    if (isReady()) {
      removeSkeleton();
      return;
    }

    observer.observe(mount, { childList: true, subtree: true });
  });
};

initializePdpImpYotpoSkeletons();
initializePdpRatingSkeletons();
